module.exports = __webpack_public_path__ + "img/logo_dark_text.e6f98f30.png";